import type { BadgeTone } from '../components/ui/Badge';

export const BOOKING_STATUS_TONE: Record<string, BadgeTone> = {
  CONFIRMED: 'success',
  CANCELLED: 'danger',
  RESCHEDULED: 'neutral',
};
